import React, { useEffect, useMemo, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { COMPANY_NAME } from "../../constants/company";
import logo from "../../assets/img/logo.png";
import footerLogo from "../../assets/img/Footer.png";
import { useLandingModals } from "./landingModalContext";

/** Home, About & Projects: dark heroes — Footer.png + light nav until scroll; logo.png once scrolled */
const DARK_HERO_NAV_PATHS = ["/", "/rapid-estimates", "/aboutus", "/ourprojects", "/services"];

const LandingNav = () => {
  const { openLetsConnect } = useLandingModals();
  const { pathname } = useLocation();
  const isDarkHeroNav = DARK_HERO_NAV_PATHS.includes(pathname);
  const [scrolled, setScrolled] = useState(false);

  const navLogoSrc = useMemo(() => {
    if (isDarkHeroNav && !scrolled) return footerLogo;
    return logo;
  }, [isDarkHeroNav, scrolled]);

  useEffect(() => {
    const nav = document.getElementById("rs-landing-nav");
    if (!nav) return;
    const onScroll = () => {
      const s = window.scrollY > 60;
      setScrolled(s);
      nav.classList.toggle("scrolled", s);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  const navClassName = ["rs-landing-nav", isDarkHeroNav ? "rs-nav-inner-hero" : ""].filter(Boolean).join(" ");

  return (
    <nav className={navClassName} id="rs-landing-nav">
      <Link to="/" className="nav-logo">
        <img src={navLogoSrc} alt={COMPANY_NAME} />
      </Link>
      <div className="nav-links">
        <NavLink to="/aboutus" className={({ isActive }) => (isActive ? "active" : "")}>
          About
        </NavLink>
        <NavLink to="/ourprojects" className={({ isActive }) => (isActive ? "active" : "")}>
          Projects
        </NavLink>
        <NavLink to="/services" className={({ isActive }) => (isActive ? "active" : "")}>
          Services
        </NavLink>
      </div>
      <button type="button" className="nav-cta" onClick={openLetsConnect}>
        Let&apos;s Connect
      </button>
    </nav>
  );
};

export default LandingNav;
